"use client";

import { useEffect, type Dispatch, type SetStateAction } from "react";
import type { ParsedTimeline } from "./timeline-types";

export interface UseTimelineParsedResetInput {
  clearTimelineTooltip: () => void;
  parsed: ParsedTimeline | null;
  resetTimelineNeedle: () => void;
  setCollapsedSections: Dispatch<SetStateAction<Set<number>>>;
}

export function useTimelineParsedReset({
  clearTimelineTooltip,
  parsed,
  resetTimelineNeedle,
  setCollapsedSections,
}: UseTimelineParsedResetInput): void {
  useEffect(() => {
    if (!parsed) {
      return;
    }

    const resetFrame = window.requestAnimationFrame(() => {
      setCollapsedSections(new Set<number>());
      resetTimelineNeedle();
      clearTimelineTooltip();
    });

    return () => {
      window.cancelAnimationFrame(resetFrame);
    };
  }, [clearTimelineTooltip, parsed, resetTimelineNeedle, setCollapsedSections]);
}
